/**
 * 미디어(이미지/비디오/오디오) 삭제 감지 — 문서 변경 전후 URL 집합을 비교해
 * 사라진 URL 을 onImageDelete 로 통지(S3 등 외부 스토리지 정리용).
 */

/**
 * 삭제 통지 대상 URL 여부. data:/blob:/file:/filesystem: 은 서버·외부 스토리지 객체가 아니므로
 * onImageDelete(→ S3 삭제 등) 대상에서 제외한다. (예: 붙여넣기 이미지가 data:→서버 URL 로 승격될 때
 * 옛 data: URL 이 "삭제됨"으로 오탐되어 거대한 data: 문자열로 삭제 API 를 호출하는 문제 방지)
 */
export function isDeletableMediaUrl(url) {
  return !/^(?:data:|blob:|file:|filesystem:)/i.test(String(url || '').trim());
}

/** blocks 트리에서 미디어 url 을 재귀 수집(삭제 대상 스킴만) */
export function collectMediaUrls(blocks, set) {
  for (const b of blocks || []) {
    if (
      b &&
      (b.type === 'image' || b.type === 'video' || b.type === 'audio') &&
      b.props &&
      b.props.url &&
      isDeletableMediaUrl(b.props.url)
    )
      set.add(b.props.url);
    if (b && Array.isArray(b.children)) collectMediaUrls(b.children, set);
  }
  return set;
}

/**
 * 삭제 감지기 생성. detect(doc) 호출마다 직전 스냅샷과 비교해 사라진 url 을 콜백.
 */
export function createMediaDeletionDetector(onImageDelete, initialBlocks) {
  let prev = collectMediaUrls(initialBlocks || [], new Set());
  return function detect(doc) {
    const cur = collectMediaUrls(doc, new Set());
    if (onImageDelete) for (const u of prev) if (!cur.has(u)) onImageDelete(u);
    prev = cur;
  };
}
